(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["harmonica-delivery-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hm-availability')) {
  customElements.define('hm-availability', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.changeHandler = () => { clearTimeout(this.updateTimer); this.updateTimer = setTimeout(() => this.showVariant(this.form?.querySelector('[name="id"]')?.value), 150); };
      this.form?.addEventListener('change', this.changeHandler);
      this.attempts = 0;
      const bind = () => {
        if (!this.isConnected) return;
        const bus = window.themeCore?.EventBus;
        if (bus) {
          bus.listen('form:' + this.dataset.section + ':change-variant', payload => {
            if (this.isConnected && payload.form === this.form) this.showVariant(payload.currentVariant?.id);
          });
        } else if (++this.attempts < 20) {
          this.bindTimer = setTimeout(bind, 250);
        }
      };
      bind();
    }
    showVariant(id) {
      let found = false;
      this.querySelectorAll('[data-hm-variant]').forEach(row => {
        const match = String(id) === row.dataset.hmVariant;
        row.hidden = !match;
        found = found || match;
      });
      this.querySelector('[data-hm-unavailable]').hidden = found;
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.changeHandler);
      clearTimeout(this.bindTimer);
      clearTimeout(this.updateTimer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
